/**
 * Subscribe to a CSS media query from React.
 *
 * The admin screens style almost entirely with inline styles, which cannot
 * carry a media query — so a layout that must genuinely CHANGE at a breakpoint
 * (not merely reflow, which flex-wrap already handles) has to ask in JS.
 *
 * Reach for flex-wrap first. This is for the cases where narrow means a
 * different arrangement, e.g. a two-pane master/detail collapsing to one pane
 * with the list behind a disclosure.
 */

import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    // Re-read on subscribe: the query can already have flipped between the
    // initial render and this effect.
    setMatches(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
